import { following } from "../constants/actionTypes";

// Mirrors the GET /members/api-v2/user-following/scope shape for a member with no follows.
const defaultScope = {
  locations: [],
  communities: { all: true, heritage_ids: [] },
  mixed: false,
  other_follows: 0
};

const defaultState = {
  scope: defaultScope,
  languages: [],
  places: [],
  // Time of the last successful follow change; My Feed uses it to skip its browser-cached list.
  changedAt: null,
  preloaders: {
    scope: false,
    locationAdd: false,
    locationRemove: false,
    communitiesSave: false,
    languages: false,
    places: false
  },
  errors: {
    scopeLoad: null,
    locationAdd: null,
    locationRemove: null,
    communitiesSave: null,
    languagesLoad: null,
    placesSearch: null
  }
};

const failure = (state, preloader, payload) => ({
  ...state,
  preloaders: { ...state.preloaders, [preloader]: false },
  errors: { ...state.errors, [payload.section]: { message: payload.message, status: payload.status } }
});

export default function followingReducer(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case following.SET_LOADING:
      return {
        ...state,
        preloaders: { ...state.preloaders, [payload.section]: payload.isLoading }
      };

    case following.GET_SCOPE:
      return {
        ...state,
        scope: payload,
        preloaders: { ...state.preloaders, scope: false },
        errors: { ...state.errors, scopeLoad: null }
      };

    case following.GET_SCOPE_FAIL:
      return failure(state, "scope", payload);

    case following.ADD_LOCATION: {
      const exists = state.scope.locations.some(location => location.key === payload.location.key);

      return {
        ...state,
        scope: { ...state.scope, locations: exists ? state.scope.locations : [...state.scope.locations, payload.location] },
        changedAt: payload.changedAt,
        preloaders: { ...state.preloaders, locationAdd: false },
        errors: { ...state.errors, locationAdd: null }
      };
    }

    case following.ADD_LOCATION_FAIL:
      return failure(state, "locationAdd", payload);

    case following.REMOVE_LOCATION:
      return {
        ...state,
        scope: { ...state.scope, locations: state.scope.locations.filter(location => location.key !== payload.key) },
        changedAt: payload.changedAt,
        preloaders: { ...state.preloaders, locationRemove: false },
        errors: { ...state.errors, locationRemove: null }
      };

    case following.REMOVE_LOCATION_FAIL:
      return failure(state, "locationRemove", payload);

    case following.SAVE_COMMUNITIES:
      return {
        ...state,
        scope: payload.scope,
        changedAt: payload.changedAt,
        preloaders: { ...state.preloaders, communitiesSave: false },
        errors: { ...state.errors, communitiesSave: null }
      };

    case following.SAVE_COMMUNITIES_FAIL:
      return failure(state, "communitiesSave", payload);

    case following.GET_LANGUAGES:
      return {
        ...state,
        languages: payload,
        preloaders: { ...state.preloaders, languages: false },
        errors: { ...state.errors, languagesLoad: null }
      };

    case following.GET_LANGUAGES_FAIL:
      return failure(state, "languages", payload);

    case following.SEARCH_PLACES:
      return {
        ...state,
        places: payload,
        preloaders: { ...state.preloaders, places: false },
        errors: { ...state.errors, placesSearch: null }
      };

    case following.SEARCH_PLACES_FAIL:
      return { ...failure(state, "places", payload), places: [] };

    case following.CLEAR_PLACES:
      return {
        ...state,
        places: [],
        preloaders: { ...state.preloaders, places: false },
        errors: { ...state.errors, placesSearch: null }
      };

    default:
      return state;
  }
}
